import { useEffect } from 'react';
import { useLocation } from 'react-router';
import { Loader } from 'components/Loader/Loader';
import { useAuthContext } from 'utils/contexts/AuthContext';

export const Logout = () => {
    const { logout } = useAuthContext();

    const { state } = useLocation();

    useEffect(() => {
        logout(state?.path);
    }, [logout, state]);

    return <Loader />;
};
